import { Component, OnInit } from '@angular/core';
import {FormBuilder, Validators} from "@angular/forms";
import {AuthService} from "../../services/auth.service";
import {Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {ChangePasswordComponent} from '../../modals/change-password/change-password.component';
import { SecurAuthService } from 'src/app/services/securauth.service';

@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.css']
})
export class LoginModalComponent implements OnInit {
 loginForm: any;
  errorMsg: any;
  submitted = false;
  isagree = true;
  constructor(private router: Router, public dialog: MatDialog,private secureAuthService:SecurAuthService, private fb: FormBuilder, public dialogRef: MatDialogRef<any>,  private _authService: AuthService, private toastr:ToastrService) { }

  ngOnInit(): void {
      this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      terms: [false, Validators.required],
    });

    this._authService.demoLoginCalled(() => {
      this.demologin();
    });
  }

   get loginFormControl() {
    return this.loginForm.controls;
  }

  demologin() {
    //this.submitted = true;
    const loginId = {username:'demo', password:'12345'};
    this._authService.logIn(loginId).subscribe({
      next: (res: any) => {
        if (res.error) {
          this.errorMsg = res.message;
        } else {
          // set time to 30min
          const now = new Date();
          const expirationTime = new Date(now.getTime() + 1 * 60 * 30 * 1000);
          const expirationTime2:any = expirationTime.getTime();

          localStorage.setItem('token', res.data['token']);
          localStorage.setItem('username', res.data['username']);
          localStorage.setItem('role', res.data['role']);
          localStorage.setItem('user_id', res.data['userId']);
          localStorage.setItem('isLoggedIn', "true");
          localStorage.setItem('expirationTime', expirationTime2);
          this.router.navigateByUrl('/dashboard/cricket');
          this.dialogRef.close();
        }
      }, error: (err) => {
        console.log('err->', err);

        if (err.error.errors[0].hasOwnProperty('username')) {
          this.errorMsg = err.error.errors[0].username;
        } else {
          this.errorMsg = err.message;
        }

      }
    });
  }

  login() {
    if (this.loginForm.value.terms === null || this.loginForm.value.terms === undefined || !this.loginForm.value.terms) {
      this.errorMsg = "Please agree terms and conditions";
      setTimeout(() => {
        this.errorMsg = "";
      },2000);
      return;
    }

    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    } else {
      this._authService.logIn(this.loginForm.value).subscribe({
        next: (res: any) => {
          if (res.error) {
            this.errorMsg = res.message;
          } else {
            console.log('res after login',res);
            // set time to 20min
            const now = new Date();
            const expirationTime = new Date(now.getTime() + 1 * 60 * 30 * 1000);
            const expirationTime2:any = expirationTime.getTime();

            localStorage.setItem('token', res.data['token']);
            // localStorage.setItem('username', res.data['username']);
            // localStorage.setItem('role', res.data['role']);
            localStorage.setItem('user_id', res.data['userId']);
            // localStorage.setItem('isLoggedIn', "true");
            // localStorage.setItem('expirationTime', expirationTime2);
            // localStorage.setItem('password_version', res.data['user_details']['password_version']);
            if (res.data['user_details']['password_version'] == '1') {
              // this.router.navigateByUrl('/dashboard/home');
              const dialogRef = this.dialog.open(ChangePasswordComponent, { position: { top: '60px' },disableClose: true, });
              dialogRef.afterClosed().subscribe(result => {
                console.log(`Dialog result: ${result}`);
              });
            } 
            if(res.data['user_details']['auth_enable']=='1'){
              this.dialogRef.close();
              const data = {
                username: this.loginForm.value.username,
                password: this.loginForm.value.password
              };
              this.secureAuthService.setData(data);
              this.router.navigateByUrl('loginauth/1');
              return ; 
            }
            else {
            localStorage.setItem('token', res.data['token']);
            localStorage.setItem('username', res.data['username']);
            localStorage.setItem('role', res.data['role']);
            localStorage.setItem('user_id', res.data['userId']);
            localStorage.setItem('isLoggedIn', "true");
            localStorage.setItem('expirationTime', expirationTime2);
            localStorage.setItem('password_version', res.data['user_details']['password_version']);
              this.router.navigateByUrl('/dashboard/cricket');
            }
            //this.router.navigateByUrl('/dashboard/home');
            this.dialogRef.close();
          }
        }, error: (err) => {
          //console.log('err->', err);

          if (err.error.errors[0].hasOwnProperty('username')) {
            this.errorMsg = err.error.errors[0].username;
          } else {
            this.errorMsg = err.message;
          }

        }
      });
    }

  }

  closeDialog() {
    this.dialogRef.close();
  }

}
